import * as Yup from 'yup';
import { FormDataSubmit } from './types.ts';
import {
  baseDocumentFieldsSchema,
  createCounterpartyNameSchema,
  createCounterpartyCodeSchema,
} from '../ApplicationValidationSchema.ts';
import { errorMessages } from '~/constants/errorMessages.js';

interface WhyRevokeFormData {
  disagreeWithProcessingPurpose?: boolean;
  disagreeWithPersonalDataScope?: boolean;
  otherReason?: boolean;
  otherReasonDescription?: string | null;
}

export const validationSchemaSubmitForm = (formData?: FormDataSubmit) =>
  Yup.object().shape({
    ...baseDocumentFieldsSchema,
    financialServicesCounterpartyName: createCounterpartyNameSchema(
      () =>
        !!(
          formData?.financialServices?.selected &&
          formData?.financialServices?.clientType === 'REPRESENTATIVE'
        )
    ),
    financialServicesCounterpartyCode: createCounterpartyCodeSchema(
      () =>
        !!(
          formData?.financialServices?.selected &&
          formData?.financialServices?.clientType === 'REPRESENTATIVE'
        ),
      { withValidation: true, withLengthValidation: true }
    ),
    businessRelationCounterpartyName: createCounterpartyNameSchema(
      () =>
        !!(
          formData?.businessRelationship?.selected &&
          formData?.businessRelationship?.clientType === 'REPRESENTATIVE'
        )
    ),
    businessRelationCounterpartyCode: createCounterpartyCodeSchema(
      () =>
        !!(
          formData?.businessRelationship?.selected &&
          formData?.businessRelationship?.clientType === 'REPRESENTATIVE'
        ),
      { withValidation: true, withLengthValidation: true }
    ),
  });

export const validationSchemaWhyRevoke = () =>
  Yup.object()
    .shape({
      disagreeWithProcessingPurpose: Yup.boolean(),
      disagreeWithPersonalDataScope: Yup.boolean(),
      otherReason: Yup.boolean(),
      otherReasonDescription: Yup.string()
        .nullable()
        .when('otherReason', {
          is: (value: boolean) => value,
          then: (schema) => schema.required(errorMessages.FIELD_REQUIRED_SHORT),
          otherwise: (schema) => schema.notRequired(),
        }),
    })
    .test(
      'at-least-one-checkbox',
      errorMessages.AT_LEAST_ONE_SELECTED,
      function (value?: WhyRevokeFormData) {
        const hasAtLeastOne = !!(
          value?.disagreeWithProcessingPurpose ||
          value?.disagreeWithPersonalDataScope ||
          value?.otherReason
        );

        if (hasAtLeastOne) {
          return true;
        }

        return this.createError({
          path: 'atLeastOneCheckbox',
          message: errorMessages.AT_LEAST_ONE_SELECTED,
        });
      }
    );
